import moment from "moment";
import validator from "validator";
import { useDispatch } from "react-redux";
import TimezonePicker from "react-timezone";
import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useNavigate, useParams } from "react-router-dom";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import Header from "../../components/Header/NewHeader";
import PhotoAvatar from "../../components/PhotoAvatar";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import ModalChangePassword from "../../components/ModalChangePassword";
import iconEngrenagemSVG from "../../assets/images/icons/icon_users_header.svg";
import { getCountries, getUsersById, postUsers, putUsers } from "../../store/middleware";

import { User } from "./styles";
import { SCButtonAddInput } from "../../components/Buttons/styles";

function NewUsers() {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isDelete] = useState("");
  const [name, setName] = useState("");
  const [open, setOpen] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [active, setActive] = useState("1");
  const [address, setAddress] = useState("");
  const [subRole, setSubRole] = useState("");
  const [picture, setPicture] = useState(null);
  const [timezone, setTimezone] = useState("");
  const [dialogMsg, setDialogMsg] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [countryId, setCountryId] = useState(212);
  const [validations, setValidations] = useState({});
  const [customGroups, setCustomGroups] = useState([]);
  const [dialogTitleMsg, setDialogTitleMsg] = useState("");
  const [inputCustomGroup, setInputCustomGroup] = useState("");
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [userEmails, setUserEmails] = useState([{ email: "", notify: true }]);
  const [userPhones, setUserPhones] = useState([{ phone: "", userPhoneTypeId: 1 }]);

  const getData = async () => {
    if (!id) return;

    await dispatch(getUsersById(id))
      .then((res) => {
        if (res?.role === "student" || res?.role === "teacher") {
          alert(`User type: ${res.result.items[0].role}`);
        }

        const arrayEmail = res?.userEmails.map((item) => ({ ...item, email: decryptIfEncrypted(item.email) }));
        const arrayPhone = res?.userPhones.map((item) => ({ ...item, phone: decryptIfEncrypted(item.phone) }));

        setUserEmails(arrayEmail);
        setUserPhones(arrayPhone);

        setRole(res?.role);
        setPicture(res?.picture);
        setTimezone(res?.timezone);
        setCountryId(res?.countryId);
        setSubRole(res?.subrole ?? "");
        setName(decryptIfEncrypted(res?.name));
        setEmail(decryptIfEncrypted(res?.email));
        setGender(decryptIfEncrypted(res?.gender));
        setActive(res?.active === true ? "1" : "0");
        setAddress(decryptIfEncrypted(res?.address));
        setBirthDate(decryptIfEncrypted(res?.birthDate));
        setCustomGroups(res?.customgroup ? res?.customgroup.split(",") : []);
      })
      .catch((err) => console.log("ERRO GET USERS ", err));
  };

  const addField = (e) => {
    e.preventDefault();

    switch (e.target.name) {
      case "addemail":
        setUserEmails((state) => [...state, { email: "", notify: false }]);
        break;
      case "addphone":
        setUserPhones((state) => [...state, { phone: "", userPhoneTypeId: "" }]);
        break;
    }

    validateForm();
  };

  const addCustomGroup = (e) => {
    e.preventDefault();

    if (inputCustomGroup.trim() !== "") {
      setInputCustomGroup("");
      setCustomGroups([...customGroups, inputCustomGroup.trim()]);
    }
  };

  const removeCustomGroup = (indexToRemove) => {
    setCustomGroups(customGroups.filter((_, index) => index !== indexToRemove));
  };

  const removeField = (e, index, name) => {
    e.preventDefault();

    switch (name) {
      case "removeemail":
        setUserEmails((state) => state.filter((_, i) => i !== index));
        break;
      case "removephone":
        setUserPhones((state) => state.filter((_, i) => i !== index));
        break;
    }

    validateForm();
  };

  const handleChangeList = (e, index) => {
    e.preventDefault();
    const { name, value } = e.target;

    switch (name) {
      case "email":
        setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, email: value } : item)));
        break;
      case "notify":
        setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: !item.notify } : item)));
        break;
      case "phone":
        setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, phone: value } : item)));
        break;
      case "userPhoneTypeId":
        setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, userPhoneTypeId: value } : item)));
        break;
    }

    validateForm();
  };

  const validateForm = () => {
    let validations = [];
    validations = {
      name: validator.isEmpty(name),
      email: !validator.isEmail(email) || validator.isEmpty(email),
      address: validator.isEmpty(address === null ? "" : address),
      countryId: countryId <= 0 ? true : false,
      timezone: validator.isEmpty(timezone),
      birthday: !birthDate || moment(birthDate) >= moment().add(-1, "hours") ? true : false,
      gender: validator.isEmpty(gender),
      phone: userPhones.length === 0 || validator.isEmpty(userPhones[0].phone),
    };

    setValidations(validations);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "timezone":
        setTimezone(value);
        break;
      case "birthDate":
        setBirthDate(value);
        break;
      case "countryId":
        setCountryId(value);
        break;
      case "role":
        setRole(value);
        break;
      case "active":
        setActive(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "subRole":
        setSubRole(value);
        break;
      default:
        break;
    }
    validateForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let objUser = {
      role,
      email,
      gender,
      address,
      timezone,
      userEmails,
      birthDate,
      userPhones,
      name: name.toString(),
      countryId: Number(countryId),
      active: active === "1" ? true : false,
    };

    objUser.subrole = subRole;

    if (subRole === "SquadManager") objUser.customgroup = customGroups.join(", ");
    else objUser.customgroup = "";

    if (id) {
      objUser.id = Number(id);

      if (objUser.userPhones.length > 0) {
        objUser.userPhones.map((item) => {
          item.userPhoneTypeId = Number(item.userPhoneTypeId);
          delete item.userPhoneType;
          delete item.id;
          delete item.userId;
          delete item.updatedAt;
          delete item.createdAt;
          delete item.deletedAt;
        });
      } else {
        delete objUser.userPhones;
      }

      if (objUser.userEmails.length > 0) {
        objUser.userEmails.map((item) => {
          delete item.id;
          delete item.userId;
          delete item.updatedAt;
          delete item.createdAt;
          delete item.deletedAt;
        });
      } else {
        delete objUser.userEmails;
      }

      dispatch(putUsers(objUser))
        .then(() => navigate(-1))
        .catch((err) => {
          try {
            let errMsg = err.response.data.error?.message ? err.response.data.error?.message : err.response.data.error;
            setOpen(true);
            setDialogMsg(errMsg);
            setDialogTitleMsg("Ops!");
          } catch (err) {
            setOpen(true);
            setDialogMsg("Sorry, something wrong ");
            setDialogTitleMsg("Ops!");
          }
        });
    } else {
      objUser.userPhones.map((item) => {
        item.userPhoneTypeId = Number(item.userPhoneTypeId);
      });

      await dispatch(postUsers(objUser))
        .then(() => navigate(-1))
        .catch((err) => {
          console.log("Error sendUser Data ", err);
          let errMsg = err.data.error.message !== undefined ? err.data.error.message : err.data.error[0].message;

          setOpen(true);
          setDialogMsg(errMsg);
          setDialogTitleMsg("Ops!");
        });
    }
  };

  const openModalChangePassword = () => setShowModalPassword(true);

  if (timezone && timezone === "America/Sao_Paulo") {
    setTimezone("America/Bahia");
  }

  let dataNew = moment(new Date()).utc().tz(timezone);
  moment.utc().tz(timezone);

  let dataTimeZone = moment(dataNew).format("LT");

  useEffect(() => {
    getData();
    dispatch(getCountries()).then((res) => setCountries(res));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu lang={"english"} />
      <section>
        <Header
          t={t}
          title={t("USERS")}
          icon={<img src={iconEngrenagemSVG} alt="iconEngrenagemSVG" />}
          typeIcon="custom"
        />

        <div className="content">
          <User>
            <div className="containerUsers">
              <div className="userName">
                <h2>{name}</h2>
              </div>
              <div className="viewUser">
                <PhotoAvatar userID={id} picture={picture} setPicture={setPicture} />

                <form className="formulario">
                  <div className="wrapperProfileActive">
                    <div className="profile">
                      <label htmlFor="role">Profile</label>

                      <select name="role" value={role} onChange={handleChange}>
                        <option value="select">{t("SELECT")}</option>
                        <option value="customerService">Customer Service</option>
                        <option value="companyManager">Company Manager</option>
                        <option value="b2b">Contato B2B</option>
                      </select>
                    </div>

                    <select
                      name="active"
                      value={active}
                      onChange={handleChange}
                      className={`selectAtive ${active === "1" ? " active" : " inactive"}`}
                    >
                      <option value={"1"}>Active</option>
                      <option value={"0"}>Inactive</option>
                    </select>
                  </div>

                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("PERSONAL_DATA")}</h4>
                  </div>

                  <div>
                    <label htmlFor="name" required={validations["name"]}>
                      {t("NAME")}
                    </label>
                    <span className="invalid">{validations["name"] && t("REQUIRED_FIELD")}</span>
                  </div>
                  <input
                    required
                    type="text"
                    name="name"
                    value={name}
                    onChange={handleChange}
                    placeholder={t("NAME_PLACEHOLDER")}
                  />

                  {userEmails?.length &&
                    userEmails?.map((item, index) => (
                      <div key={index}>
                        <div>
                          <label htmlFor={"email" + index}>{index === 0 ? t("EMAIL") : t("EXTRA_EMAIL")} </label>
                        </div>
                        <div className="notification">
                          <input
                            required
                            type="text"
                            name="email"
                            value={item.email}
                            placeholder={index === 0 ? t("EMAIL_PLACEHOLDER") : t("EXTRA_EMAIL_PLACEHOLDER")}
                            onChange={(e) => {
                              if (index === 0) handleChange(e);
                              handleChangeList(e, index);
                            }}
                          />
                          <div className="switchBox">
                            <div className="switch__container">
                              <input
                                className="switch switch--shadow"
                                name="notify"
                                id={"notify" + index}
                                type="checkbox"
                                onChange={(e) => handleChangeList(e, index)}
                                checked={item.notify}
                              />
                              <label className="labelNotify" htmlFor={"notify" + index}>
                                <span>{t("NOTIFICATION")}</span>
                                <span className="doubleClick">{t("DOUBLE_CLICK")}</span>
                              </label>
                            </div>
                          </div>
                          {index > 0 ? (
                            <SCButtonAddInput
                              id={index}
                              name="remove"
                              onClick={(e) => removeField(e, index, "removeemail")}
                            >
                              {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                            </SCButtonAddInput>
                          ) : (
                            <SCButtonAddInput name="addemail" onClick={(e) => addField(e)}>
                              {t("ADD_EMAIL")} +
                            </SCButtonAddInput>
                          )}
                        </div>
                      </div>
                    ))}

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label htmlFor="gender">{t("GENDER")}</label>
                        <span className="invalid">{validations["gender"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <select name="gender" value={gender} onChange={handleChange}>
                        <option value="">{t("SELECT")}</option>
                        <option value="notInformed">{t("NOT_INFORMED")}</option>
                        <option value="male">{t("MALE")}</option>
                        <option value="female">{t("FEMALE")}</option>
                      </select>
                    </div>

                    <div className="lineInputs">
                      <div>
                        <label htmlFor="birthDate">{t("BIRTH_DATE")}</label>
                        <span className="invalid">{validations["birthday"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <input type="date" id="date" name="birthDate" value={birthDate} onChange={handleChange} />
                    </div>
                  </div>

                  <div className="wrapperBlock">
                    <h4 className="textBlock">{t("COUNTRY")}</h4>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs">
                      <div>
                        <label htmlFor="countryId">{t("COUNTRY")}</label>
                        <span className="invalid">{validations["countryId"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <select name="countryId" value={countryId} onChange={handleChange}>
                        <option value="0">{t("SELECT")}</option>
                        {countries?.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="inputs">
                    <div className="lineInputs timezoneCard">
                      <div>
                        <label htmlFor="timezone">{t("TIMEZONE")} </label>
                        <span className="invalid">{validations["timezone"] && t("REQUIRED_FIELD")}</span>
                      </div>
                      <TimezonePicker
                        value={timezone}
                        onChange={(timezoneName) => {
                          setTimezone(timezoneName);
                          validateForm();
                        }}
                        inputProps={{
                          placeholder: "Select Timezone...",
                          name: "timezone",
                        }}
                      />
                    </div>
                    <div className="lineInputs">
                      {/* <p>{t("CURRENT_TIME")}<br /> {t("IN_THIS_TIMEZONE")}: { moment.tz(this.state.timezone).format('LT') }</p> */}
                      <p>
                        {t("CURRENT_TIME")}
                        <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                      </p>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="address">{t("ADDRESS")} </label>
                    <span className="invalid">{validations["address"] && t("REQUIRED_FIELD")}</span>
                  </div>
                  <input
                    required
                    name="address"
                    value={address}
                    onChange={handleChange}
                    placeholder={t("ADDRESS_PLACEHOLDER")}
                  />

                  {userPhones.map((item, index) => {
                    return (
                      <div key={index} className="inputs telefone">
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"phone" + index}>{t("TELEPHONE")}</label>
                            {index === 0 && (
                              <span className="invalid">{validations["phone"] && t("REQUIRED_FIELD")}</span>
                            )}
                          </div>
                          <input
                            name="phone"
                            value={item.phone}
                            id={"phone" + index}
                            className="inputMobile"
                            required={index === 0}
                            placeholder={t("PHONE_PLACEHOLDER")}
                            onChange={(e) => handleChangeList(e, index)}
                          />
                        </div>
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"userPhoneTypeId" + index}>{t("TYPE")}</label>
                          </div>
                          <select
                            name="userPhoneTypeId"
                            id={"phoneType" + index}
                            className="inputMobile"
                            value={item.userPhoneTypeId || 15}
                            onChange={(e) => handleChangeList(e, index)}
                          >
                            <option value="15">{t("SELECT")}</option>
                            <option value="1">{t("COMMERCIAL")}</option>
                            <option value="2">{t("RESIDENCIAL")}</option>
                            <option value="3">{t("CELLPHONE")}</option>
                            <option value="4">{t("WHATSAPP")}</option>
                          </select>
                        </div>
                        {index === 0 && (
                          <div className="lineInputs">
                            <SCButtonAddInput name="addphone" onClick={(e) => addField(e)}>
                              {t("BTN_ADD_TEL")} +
                            </SCButtonAddInput>
                          </div>
                        )}
                        {index > 0 && (
                          <SCButtonAddInput
                            id={index}
                            name="remove"
                            onClick={(e) => removeField(e, index, "removephone")}
                          >
                            {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                          </SCButtonAddInput>
                        )}
                      </div>
                    );
                  })}

                  <div>
                    <div className="wrapperBlock">
                      <h4 className="textBlock">{t("DEPARTMENT")}</h4>
                    </div>

                    <div className="inputs">
                      <div className="lineInputs">
                        <div>
                          <label htmlFor="language">SubRole</label>
                        </div>
                        <div>
                          <select
                            name="subRole"
                            value={subRole}
                            onChange={handleChange}
                            className="language inputMobile"
                          >
                            <option value="">{t("SELECT")}</option>
                            <option value={"EconomicGroup"}>EconomicGroup</option>
                            <option value={"CompanyManager"}>CompanyManager</option>
                            <option value={"ContractManager"}>ContractManager</option>
                            <option value={"SquadManager"}>SquadManager</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {subRole === "SquadManager" && (
                      <div className="lineInputs">
                        <div>
                          <label htmlFor="language">CustomGroup</label>
                        </div>
                        <div>
                          <div style={{ display: "flex", gap: 4 }}>
                            <input
                              type="text"
                              style={{ width: 200 }}
                              value={inputCustomGroup}
                              placeholder="Digite algo..."
                              onChange={(e) => setInputCustomGroup(e.target.value)}
                            />
                            <div style={{ marginTop: 2 }}>
                              <SCButtonAddInput name="addCustomGroup" onClick={addCustomGroup}>
                                Add CustomGroup +
                              </SCButtonAddInput>
                            </div>
                          </div>

                          <div className="customGroups-list">
                            {customGroups.map((tag, index) => (
                              <div key={index} className="customGroups">
                                <span className="text-sm font-medium">{tag}</span>
                                <button type="button" onClick={() => removeCustomGroup(index)} className="remove-btn">
                                  <i className="fa fa-times-circle-o fa-lg" />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="wrapperConfigButtons">
                    <div>
                      <div>
                        <label htmlFor="password">{t("PASSWORD")}</label>
                      </div>
                      <button type="button" className="password" onClick={openModalChangePassword}>
                        {t("CHANGE_PASSWORD")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>
                {t("BACK")}
              </button>
              <button className="save" onClick={handleSubmit}>
                {t("BTN_SAVE")}
              </button>
            </div>
          </User>

          <Dialog
            open={open}
            keepMounted
            className="boxModal"
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title" className="boxModal">
              {dialogTitleMsg}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description" className="boxModal">
                {dialogMsg}
              </DialogContentText>
            </DialogContent>
            <br />
            <DialogActions className="boxModal">
              {isDelete && (
                <Button onClick={() => {}} color="primary">
                  Yes, delete
                </Button>
              )}

              <Button onClick={() => setOpen(false)} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <ModalChangePassword id={id} showModal={showModalPassword} setShowModal={setShowModalPassword} />
        </div>
      </section>
    </div>
  );
}

export default NewUsers;
